import styled from 'styled-components'

import { BREAKPOINT } from 'styles/breakpoints'

export const StyledPeopleDetails = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media screen and (min-width: ${BREAKPOINT.MD}px) {
    align-items: center;
    flex-direction: row;
  }
`

export const StyledPeopleName = styled.div`
  display: flex;
  flex-grow: 1;
  word-break: break-word;
  padding: 0 0.8rem 0 0;

  @media screen and (min-width: ${BREAKPOINT.MD}px) {
    flex-grow: 0;
    width: 12.5rem;
  }
`

export const StyledBusinessListItemWrapper = styled.div`
  word-break: break-word;
  padding: 0 0.8rem 0 0;
  display: flex;
  flex-wrap: wrap;

  @media screen and (min-width: ${BREAKPOINT.XS}px) {
    padding: 0;
    width: 15rem;
  }
  @media screen and (min-width: ${BREAKPOINT.MD}px) {
    padding: 0;
    width: 18rem;
  }
  @media screen and (min-width: ${BREAKPOINT.LG}px) {
    padding: 0;
    width: 27rem;
  }
  @media screen and (min-width: ${BREAKPOINT.XL}px) {
    padding: 0;
    width: 33rem;
  }
`

export const StyledAvatar = styled.div`
  width: 3rem;
  height: 3rem;
`
